import { render, staticRenderFns } from "./TableLineMoreActions.vue?vue&type=template&id=c12962a8"
import script from "./TableLineMoreActions.vue?vue&type=script&lang=js"
export * from "./TableLineMoreActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports